<script>
  export let name;
  export let width = "16px";
  export let height = "16px";
  export let focusable = false;
  export let strokeWidth = "1";
  export let color = "currentColor";
  export let fill = "none";

  let icons = [
    {
      boxY: 24,
      boxX: 24,
      name: "home",
      svg: `<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "bar-chart",
      svg: `<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>`,
    },
    {
      boxY: 12,
      boxX: 12,
      name: "minus",
      svg: `<path d="M9.77813 6.88909H1.99995" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 12,
      boxX: 12,
      name: "fire",
      svg: `<path d="M10 4.0498L4.5 9.5498L2 7.0498" stroke="#65C82D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 12,
      boxX: 12,
      name: "check",
      svg: `<path d="M4 12.6111L8.92308 17.5L20 6.5" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "external-link",
      svg: `<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "log-out",
      svg: `<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "lock",
      svg: `<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "mail",
      svg: `<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "key",
      svg: `<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "plus-square",
      svg: `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "plus-accordion",
      svg: `<path d="M12.5 5.5V19.5" stroke="#CC3129" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.5 12.5H19.5" stroke="#CC3129" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "minus-accordion",
      svg: `<path d="M5.5 12.5H19.5" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "help-circle",
      svg: `<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "divide",
      svg: `<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "globe",
      svg: `<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "smartphone",
      svg: `<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "target",
      svg: `<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "chevron-right",
      svg: `<polyline points="9 18 15 12 9 6"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "chevron-left",
      svg: `<polyline points="15 18 9 12 15 6"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "x-circle",
      svg: `<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "corner-down-right",
      svg: `<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "corner-left-up",
      svg: `<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "trash-2",
      svg: `<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "eye-off",
      svg: `<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "eye",
      svg: `<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "star",
      svg: `<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "thumbs-up",
      svg: `<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "user",
      svg: `<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "clock",
      svg: `<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "facebook",
      svg: `<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "twitter",
      svg: `<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "gift",
      svg: `<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "log-in",
      svg: `<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "info",
      svg: `<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "menu",
      svg: `<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "minus-square",
      svg: `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "rotate-cw",
      svg: `<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "search",
      svg: `<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "search-no-results",
      svg: `<g fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m13.5 8.5l-5 5"/><circle cx="11" cy="11" r="8"/><path d="m21 21l-4.3-4.3"/></g>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "zap",
      svg: `<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "award",
      svg: `<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "instagram",
      svg: `<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "youtube",
      svg: `<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "edit",
      svg: `<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "chevron-down",
      svg: `<polyline points="6 9 12 15 18 9"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "chevron-up",
      svg: `<polyline points="18 15 12 9 6 15"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "check-circle",
      svg: `<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "edit-2",
      svg: `<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "tool",
      svg: `<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "refresh-cw",
      svg: `<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "dribbble",
      svg: `<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "linkedin",
      svg: `<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "columns",
      svg: `<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "save",
      svg: `<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "tablet",
      svg: `<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "monitor",
      svg: `<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "layers",
      svg: `<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "compass",
      svg: `<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "settings",
      svg: `<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "file-text",
      svg: `<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "users",
      svg: `<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "image",
      svg: `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "user-plus",
      svg: `<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "more-vertical",
      svg: `<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "more-horizontal",
      svg: `<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "list",
      svg: `<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "phone",
      svg: `<path d="M22.82 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "database",
      svg: `<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "folder",
      svg: `<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "upload-cloud",
      svg: `<polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/><polyline points="16 16 12 12 8 16"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "alert-circle",
      svg: `<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "grid",
      svg: `<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>`,
    },
    {
      boxY: 8,
      boxX: 16,
      name: "arrow-right",
      svg: `<path d="M1 13.0796L7 7.07959L1 1.07959" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "arrow-right-pointer",
      svg: `<path fill="currentColor" d="M4 11v2h12l-5.5 5.5l1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5L16 11z"/>`,
    },
    {
      boxY: 8,
      boxX: 16,
      name: "arrow-left",
      svg: `<path d="M7 1.07959L1 7.07959L7 13.0796" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 8,
      boxX: 20,
      name: "arrow-down",
      svg: `<path d="M15.5606 0.940022C15.2793 0.659122 14.8981 0.501343 14.5006 0.501343C14.1031 0.501343 13.7218 0.659121 13.4406 0.940022L8.00059 6.38002L2.56059 0.940022C2.27624 0.675062 1.90015 0.530816 1.51154 0.537672C1.12294 0.544529 0.752171 0.701952 0.477344 0.976778C0.202518 1.2516 0.0450935 1.62237 0.0382375 2.01098C0.0313806 2.39958 0.175629 2.77567 0.440589 3.06002L6.94059 9.56002C7.22184 9.84092 7.60309 9.9987 8.00059 9.9987C8.39809 9.9987 8.77934 9.84092 9.06059 9.56002L15.5606 3.06002C15.8415 2.77877 15.9993 2.39752 15.9993 2.00002C15.9993 1.60252 15.8415 1.22127 15.5606 0.940022Z" fill="white"/>`,
    },
    {
      boxY: 8,
      boxX: 20,
      name: "arrow-down-full",
      svg: `<path d="M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z"/>`,
    },
    {
      boxY: 16,
      boxX: 16,
      name: "arrow-up-right",
      svg: `<path fill-rule="evenodd" stroke-width="1" clip-rule="evenodd" d="M0.832439 15.1794C0.621461 14.9685 0.502935 14.6823 0.502936 14.3839C0.502935 14.0856 0.621461 13.7994 0.83244 13.5884L11.6406 2.78032L5.87058 2.78032C5.71959 2.78565 5.56908 2.76051 5.42802 2.70641C5.28696 2.65231 5.15825 2.57035 5.04955 2.46542C4.94086 2.3605 4.85441 2.23475 4.79536 2.09569C4.73632 1.95663 4.70589 1.8071 4.70589 1.65602C4.70589 1.50494 4.73632 1.35541 4.79536 1.21635C4.85441 1.07729 4.94086 0.95154 5.04955 0.846613C5.15825 0.741687 5.28696 0.659728 5.42802 0.605626C5.56908 0.551524 5.71959 0.526389 5.87058 0.531719L14.3559 0.531719C14.654 0.531905 14.9398 0.650416 15.1507 0.861224C15.3615 1.07203 15.48 1.35789 15.4802 1.65602L15.4802 10.1413C15.4699 10.4326 15.3469 10.7086 15.1372 10.911C14.9275 11.1135 14.6474 11.2266 14.3559 11.2266C14.0644 11.2266 13.7842 11.1135 13.5745 10.911C13.3648 10.7086 13.2418 10.4326 13.2316 10.1413L13.2316 4.37131L2.42343 15.1794C2.21245 15.3904 1.9263 15.5089 1.62794 15.5089C1.32957 15.5089 1.04342 15.3904 0.832439 15.1794Z" fill="black"/>`,
    },
    {
      boxY: 16,
      boxX: 16,
      name: "lightning",
      svg: `<path d="M8.66667 1.33301L2 9.33301H8L7.33333 14.6663L14 6.66634H8L8.66667 1.33301Z" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 12,
      boxX: 12,
      name: "cross",
      svg: `<path d="M9 3L3 9" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 3L9 9" stroke="#FF0000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
    {
      boxY: 20,
      boxX: 20,
      name: "trophy",
      svg: `<path d="M15 9C15.7956 9 16.5587 8.68393 17.1213 8.12132C17.6839 7.55871 18 6.79565 18 6H20C20.0001 6.66511 19.8676 7.32356 19.6101 7.9368C19.3526 8.55004 18.9753 9.10574 18.5004 9.57136C18.0254 10.037 17.4624 10.4032 16.8441 10.6485C16.2259 10.8938 15.565 11.0133 14.9 11C14.704 11.9609 14.2298 12.8429 13.5364 13.5364C12.8429 14.2298 11.9609 14.704 11 14.9V17L16 19V20H4V19L9 17V14.9C8.03911 14.704 7.15706 14.2298 6.46362 13.5364C5.77018 12.8429 5.29597 11.9609 5.1 11H5C3.67392 11 2.40215 10.4732 1.46447 9.53553C0.526784 8.59785 0 7.32608 0 6H2C2 6.79565 2.31607 7.55871 2.87868 8.12132C3.44129 8.68393 4.20435 9 5 9V4H2V6H0L0 2H5V0H15V2H20V6H18V4H15V9Z" fill="{fill}"/>`,
    },
    {
      boxY: 64,
      boxX: 64,
      name: "total-operators",
      svg: `<path d="M22.82 16.69c-.22-.73-.81-1.31-1.6-1.44l-2.77-.47-1.3-2.49c-.36-.68-1.05-1.1-1.82-1.1s-1.46.42-1.82 1.1l-1.3 2.49-2.77.47a2.05 2.05 0 0 0-1.13 3.45l1.96 2.01-.41 2.78c-.01.1-.02.2-.02.3 0 1.13.92 2.05 2.05 2.05.29 0 .59-.08.85-.2v30.45A3.91 3.91 0 0 0 16.65 60h30.67a3.91 3.91 0 0 0 3.91-3.91V25.64c.27.12.56.2.85.2 1.13 0 2.05-.92 2.05-2.05 0-.1 0-.2-.02-.3l-.41-2.78 1.96-2.01a2.05 2.05 0 0 0-1.13-3.45l-2.77-.47-1.3-2.49c-.36-.68-1.05-1.1-1.82-1.1s-1.46.42-1.82 1.1l-1.3 2.49-2.77.47c-.79.13-1.39.71-1.6 1.44h-2.76l-.1-.69 2.54-2.6a2.51 2.51 0 0 0-1.37-4.22l-3.59-.61-1.69-3.22c-.43-.83-1.28-1.34-2.22-1.34s-1.78.51-2.22 1.34l-1.69 3.22-3.59.61a2.493 2.493 0 0 0-2.08 2.47c0 .66.25 1.28.71 1.75l2.54 2.6-.1.69h-2.76zm-10.97 7.09.48-3.27a.995.995 0 0 0-.27-.84l-2.28-2.45 3.26-.55c.31-.05.57-.25.72-.52l1.58-2.95s.04.01.05.03l1.53 2.93c.15.28.41.47.72.52l3.28.64-2.31 2.36c-.22.22-.32.54-.27.84l.4 3.32-2.96-1.46c-.14-.07-.29-.1-.44-.1s-.3.03-.44.1l-3.04 1.41zM47.34 58H16.66c-1.05 0-1.91-.86-1.91-1.91V31.13h34.5v24.96c0 1.05-.86 1.91-1.91 1.91zm-.96-41.34c.31-.05.57-.25.72-.52l1.58-2.95s.04.01.05.03l1.53 2.92c.15.28.41.47.72.52l3.28.64-2.31 2.36c-.22.22-.32.54-.27.84l.4 3.32-2.96-1.46c-.14-.07-.29-.1-.44-.1s-.3.03-.44.1l-3.03 1.41.48-3.27a.995.995 0 0 0-.27-.84l-2.28-2.45 3.26-.55zm-4.72 2.03 1.96 2.02-.41 2.78c-.01.1-.02.2-.02.3a2.053 2.053 0 0 0 2.96 1.84l2.52-1.25.57.28v4.47H14.75v-4.47l.57-.28 2.51 1.24a2.053 2.053 0 0 0 2.96-1.84c0-.1 0-.2-.02-.3l-.41-2.78 1.96-2.01h2.95l-.13.9c-.02.12-.03.24-.03.36a2.5 2.5 0 0 0 3.61 2.24l3.26-1.61 3.26 1.61a2.5 2.5 0 0 0 3.61-2.24c0-.12 0-.24-.03-.36l-.13-.91h2.94zM24.58 12a.518.518 0 0 1-.14-.35c0-.24.18-.45.42-.5l4.08-.69c.31-.05.57-.25.72-.52l1.92-3.66c.17-.33.72-.33.89 0l1.92 3.66c.15.28.41.47.72.52l4.08.7a.5.5 0 0 1 .28.84l-2.89 2.96c-.22.22-.32.54-.27.84l.6 4.16c0 .35-.41.61-.72.45l-3.71-1.83c-.14-.07-.29-.1-.44-.1s-.3.03-.44.1l-3.71 1.84c-.3.15-.72-.08-.72-.52l.6-4.09a.995.995 0 0 0-.27-.84l-2.89-2.96z"/><path d="M25.28 24.29c-.55 0-1 .45-1 1s.45 1 1 1h13.44c.55 0 1-.45 1-1s-.45-1-1-1H25.28zM21.13 33.46c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06zM32 33.46c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06zM42.87 33.46c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06zM21.13 44.76c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06zM32 44.76c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06zM42.87 44.76c-2.24 0-4.06 1.82-4.06 4.06s1.82 4.06 4.06 4.06 4.06-1.82 4.06-4.06-1.82-4.06-4.06-4.06zm0 6.12c-1.12 0-2.06-.94-2.06-2.06s.92-2.06 2.06-2.06 2.06.92 2.06 2.06-.94 2.06-2.06 2.06z"/>`,
    },
    {
      boxY: 64,
      boxX: 64,
      name: "bullseye",
      svg: `<path d="M60 8.59a1 1 0 0 0 0-2h-2.59V4a1 1 0 0 0-2 0v3.18l-.8.8V4a1 1 0 0 0-2 0v6l-.84.83a29 29 0 1 0 1.42 1.42l.84-.84h6a1 1 0 0 0 0-2H56l.79-.8zM59 32a27 27 0 1 1-8.64-19.77l-3 3a22.75 22.75 0 1 0 1.42 1.42l3-3A26.91 26.91 0 0 1 59 32zm-24.26 0A2.74 2.74 0 1 1 32 29.26a2.63 2.63 0 0 1 1.09.24l-1.8 1.79a1 1 0 0 0 1.42 1.42l1.8-1.8a2.8 2.8 0 0 1 .23 1.09zm-.18-4A4.78 4.78 0 1 0 36 29.44l2.63-2.63a8.44 8.44 0 1 1-1.41-1.41zm4.06-4A10.42 10.42 0 1 0 40 25.38l3-3A14.61 14.61 0 1 1 41.64 21zm4.43-4.43A16.74 16.74 0 1 0 44.46 21l2.87-2.86a20.8 20.8 0 1 1-1.42-1.42z" data-name="Target"/>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "median-score",
      svg: `<g id="Rate"><path id="Layer" class="s0" d="m2.1 1.9q-0.1 0-0.2 0.1-0.1 0-0.2 0.1 0 0-0.1 0.1 0 0.1 0 0.2v19.6q0 0.1 0 0.2 0.1 0.1 0.1 0.2 0.1 0 0.2 0.1 0.1 0 0.2 0h19.6q0.2 0 0.3-0.1 0.1-0.2 0.1-0.4 0-0.2-0.1-0.4-0.1-0.1-0.4-0.1h-19v-19.1q0-0.1-0.1-0.2 0-0.1-0.1-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1z"/><path id="Layer" fill-rule="evenodd" class="s0" d="m6.3 13.1q0.1-0.1 0.1-0.2 0.1 0 0.2-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0.1 0.1 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2v0.7q0 0.1-0.1 0.1 0 0.1-0.1 0.2 0 0.1-0.1 0.1-0.1 0.1-0.2 0.1-0.1 0-0.2-0.1-0.1 0-0.2-0.1 0-0.1-0.1-0.1 0-0.1 0-0.2v-0.7q0-0.1 0-0.2zm5.4-11.5q0 0.1-0.1 0.2-0.1 0-0.1 0.1-0.1 0-0.2 0-0.1 0-0.2 0-0.1-0.1-0.2-0.1-0.1-0.1-0.1-0.2 0-0.1 0-0.2v-0.6q0-0.1 0-0.2 0-0.1 0.1-0.2 0.1-0.1 0.2-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0 0.1 0.1 0.1 0.1 0.2 0.1 0.1 0.1 0.2v0.6q0 0.1-0.1 0.2zm4.7 9.6q-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.2v-0.6q0-0.1 0.1-0.2 0-0.1 0.1-0.2 0-0.1 0.1-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0 0.2 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2v0.6q0 0.1 0 0.2-0.1 0.1-0.1 0.2-0.1 0.1-0.2 0.1-0.1 0-0.2 0-0.1 0-0.2 0zm5-12.7q0 0.1-0.1 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0-0.2-0.1-0.1 0-0.1-0.1-0.1 0-0.1-0.1-0.1-0.1-0.1-0.2v-0.7q0-0.1 0.1-0.2 0-0.1 0.1-0.2 0 0 0.1-0.1 0.1 0 0.2 0 0.1 0 0.2 0 0.1 0.1 0.2 0.1 0.1 0.1 0.1 0.2 0 0.1 0 0.2v0.7q0 0.1 0 0.2zm0.7 15.8q-0.1 0.1-0.1 0.2-0.1 0.1-0.2 0.1-0.1 0-0.2 0h-4.9q-0.1 0-0.2 0-0.1 0-0.2-0.1 0-0.1-0.1-0.2 0-0.1 0-0.2v-1.8q0-0.1 0-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.2-0.1 0.1 0 0.2 0h4.9q0.1 0 0.2 0 0.1 0 0.2 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2v1.8q0 0.1 0 0.2zm-1-1.5h-3.9v0.8h3.9zm-1.5 2.6q0.1 0 0.2 0 0.1 0 0.2 0.1 0 0.1 0.1 0.2 0 0.1 0 0.2 0 0.1 0 0.2-0.1 0-0.1 0.1-0.1 0.1-0.2 0.1-0.1 0.1-0.2 0.1h-2.9q-0.1 0-0.2-0.1-0.1 0-0.2-0.1 0-0.1-0.1-0.1 0-0.1 0-0.2 0-0.1 0-0.2 0.1-0.1 0.1-0.2 0.1-0.1 0.2-0.1 0.1 0 0.2 0z"/></g>`,
    },
    {
      boxY: 16,
      boxX: 16,
      name: "verified",
      svg: `<g clip-path="url(#clip0_0_4389)">
<path d="M15.0067 9.17325C14.7594 8.83197 14.6263 8.42133 14.6263 7.99991C14.6263 7.5785 14.7594 7.16785 15.0067 6.82658L15.5133 6.12658C15.5753 6.0411 15.6161 5.94213 15.6323 5.83782C15.6485 5.73351 15.6397 5.62684 15.6067 5.52658C15.5733 5.42737 15.5174 5.33724 15.4434 5.26322C15.3693 5.1892 15.2792 5.13331 15.18 5.09991L14.36 4.83325C13.9583 4.70367 13.6082 4.44981 13.3601 4.10831C13.1121 3.7668 12.979 3.35532 12.98 2.93325V2.06658C12.9799 1.96136 12.9549 1.85764 12.9071 1.76393C12.8592 1.67021 12.7899 1.58915 12.7047 1.52738C12.6195 1.46561 12.5209 1.42487 12.417 1.40851C12.313 1.39215 12.2067 1.40063 12.1067 1.43325L11.28 1.69991C10.8787 1.82978 10.4466 1.82943 10.0454 1.69892C9.64432 1.5684 9.29474 1.31441 9.04667 0.973246L8.54 0.273246C8.47531 0.192118 8.39317 0.126609 8.29968 0.0815863C8.20619 0.0365635 8.10376 0.0131836 8 0.0131836C7.89624 0.0131836 7.79381 0.0365635 7.70032 0.0815863C7.60683 0.126609 7.52469 0.192118 7.46 0.273246L6.95333 0.973246C6.70527 1.31441 6.35568 1.5684 5.95456 1.69892C5.55344 1.82943 5.12133 1.82978 4.72 1.69991L3.89334 1.43325C3.7933 1.40063 3.68695 1.39215 3.58301 1.40851C3.47907 1.42487 3.38047 1.46561 3.29529 1.52738C3.21011 1.58915 3.14076 1.67021 3.09291 1.76393C3.04506 1.85764 3.02008 1.96136 3.02 2.06658V2.93325C3.02102 3.35532 2.88791 3.7668 2.63987 4.10831C2.39183 4.44981 2.0417 4.70367 1.64 4.83325L0.820002 5.09991C0.720796 5.13331 0.63066 5.1892 0.556643 5.26322C0.482625 5.33724 0.426732 5.42737 0.393335 5.52658C0.360276 5.62684 0.351498 5.73351 0.367725 5.83782C0.383951 5.94213 0.424717 6.0411 0.486668 6.12658L0.993335 6.82658C1.24056 7.16785 1.37368 7.5785 1.37368 7.99991C1.37368 8.42133 1.24056 8.83197 0.993335 9.17325L0.486668 9.87325C0.424717 9.95872 0.383951 10.0577 0.367725 10.162C0.351498 10.2663 0.360276 10.373 0.393335 10.4732C0.426732 10.5725 0.482625 10.6626 0.556643 10.7366C0.63066 10.8106 0.720796 10.8665 0.820002 10.8999L1.64 11.1666C2.0417 11.2962 2.39183 11.55 2.63987 11.8915C2.88791 12.233 3.02102 12.6445 3.02 13.0666V13.9332C3.02008 14.0385 3.04506 14.1422 3.09291 14.2359C3.14076 14.3296 3.21011 14.4107 3.29529 14.4724C3.38047 14.5342 3.47907 14.575 3.58301 14.5913C3.68695 14.6077 3.7933 14.5992 3.89334 14.5666L4.71334 14.2999C5.11552 14.1679 5.54927 14.1671 5.95192 14.2977C6.35457 14.4283 6.70526 14.6836 6.95333 15.0266L7.46 15.7266C7.52224 15.8113 7.60356 15.8802 7.69737 15.9277C7.79118 15.9752 7.89485 16 8 16C8.10515 16 8.20882 15.9752 8.30263 15.9277C8.39644 15.8802 8.47776 15.8113 8.54 15.7266L9.04667 15.0266C9.29515 14.6841 9.64587 14.4292 10.0484 14.2986C10.4509 14.168 10.8844 14.1685 11.2867 14.2999L12.1067 14.5666C12.2067 14.5992 12.313 14.6077 12.417 14.5913C12.5209 14.575 12.6195 14.5342 12.7047 14.4724C12.7899 14.4107 12.8592 14.3296 12.9071 14.2359C12.9549 14.1422 12.9799 14.0385 12.98 13.9332V13.0666C12.979 12.6445 13.1121 12.233 13.3601 11.8915C13.6082 11.55 13.9583 11.2962 14.36 11.1666L15.18 10.8999C15.2792 10.8665 15.3693 10.8106 15.4434 10.7366C15.5174 10.6626 15.5733 10.5725 15.6067 10.4732C15.6397 10.373 15.6485 10.2663 15.6323 10.162C15.6161 10.0577 15.5753 9.95872 15.5133 9.87325L15.0067 9.17325ZM11.14 7.13791L7.80667 10.4712C7.68165 10.5962 7.51211 10.6664 7.33533 10.6664C7.15856 10.6664 6.98902 10.5962 6.864 10.4712L4.864 8.47125C4.80033 8.40975 4.74954 8.33618 4.7146 8.25485C4.67966 8.17351 4.66127 8.08603 4.6605 7.99751C4.65973 7.90899 4.6766 7.82121 4.71012 7.73928C4.74364 7.65735 4.79314 7.58291 4.85574 7.52032C4.91833 7.45772 4.99277 7.40822 5.0747 7.3747C5.15663 7.34118 5.24442 7.32431 5.33294 7.32508C5.42146 7.32585 5.50894 7.34424 5.59027 7.37918C5.67161 7.41412 5.74517 7.46491 5.80667 7.52858L7.33333 9.05725L10.1953 6.19525C10.3211 6.07381 10.4895 6.00661 10.6643 6.00813C10.8391 6.00965 11.0063 6.07976 11.1299 6.20337C11.2535 6.32697 11.3236 6.49418 11.3251 6.66898C11.3266 6.84378 11.2594 7.01218 11.138 7.13791H11.14Z" fill="white"/>
<path d="M10.6666 6.3335L6.99998 10.0002L5.33331 8.3335" stroke="#2CA5E4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_0_4389">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>`,
    },
    {
      boxY: 16,
      boxX: 16,
      name: "rocket",
      svg: '<path d="M2.66667 8.66613C2.11333 8.66613 1.61333 8.8928 1.25333 9.2528C0.466667 10.0395 0 13.3328 0 13.3328C0 13.3328 3.29333 12.8661 4.08 12.0795C4.44 11.7195 4.66667 11.2195 4.66667 10.6661C4.66667 9.55947 3.77333 8.66613 2.66667 8.66613ZM3.14 11.1395C2.95333 11.3261 1.69333 11.6461 1.69333 11.6461C1.69333 11.6461 2.00667 10.3928 2.2 10.1995C2.31333 10.0728 2.48 9.99947 2.66667 9.99947C3.03333 9.99947 3.33333 10.2995 3.33333 10.6661C3.33333 10.8528 3.26 11.0195 3.14 11.1395ZM10.28 7.76613C14.52 3.52613 13.1067 0.226133 13.1067 0.226133C13.1067 0.226133 9.80667 -1.1872 5.56667 3.0528L3.90667 2.71947C3.47333 2.6328 3.02 2.7728 2.7 3.08613L0 5.7928L3.33333 7.21947L6.11333 9.99947L7.54 13.3328L10.24 10.6328C10.5533 10.3195 10.6933 9.86613 10.6067 9.42613L10.28 7.76613ZM3.60667 5.88613L2.33333 5.33947L3.64667 4.02613L4.60667 4.21947C4.22667 4.7728 3.88667 5.3528 3.60667 5.88613ZM7.99333 10.9995L7.44667 9.72613C7.98 9.44613 8.56 9.10613 9.10667 8.72613L9.3 9.68613L7.99333 10.9995ZM9.33333 6.82613C8.45333 7.70613 7.08 8.42613 6.64 8.64613L4.68667 6.6928C4.9 6.25947 5.62 4.88613 6.50667 3.99947C9.62667 0.879467 11.9933 1.33947 11.9933 1.33947C11.9933 1.33947 12.4533 3.70613 9.33333 6.82613ZM8.66667 5.99947C9.4 5.99947 10 5.39947 10 4.66613C10 3.9328 9.4 3.3328 8.66667 3.3328C7.93333 3.3328 7.33333 3.9328 7.33333 4.66613C7.33333 5.39947 7.93333 5.99947 8.66667 5.99947Z" fill="white"/>',
    },
    {
      boxY: 18,
      boxX: 20,
      name: "share",
      svg: '<path d="M15 20C14.1667 20 13.4583 19.7083 12.875 19.125C12.2917 18.5417 12 17.8333 12 17C12 16.8833 12.0083 16.7623 12.025 16.637C12.0417 16.5117 12.0667 16.3993 12.1 16.3L5.05 12.2C4.76667 12.45 4.45 12.646 4.1 12.788C3.75 12.93 3.38333 13.0007 3 13C2.16667 13 1.45833 12.7083 0.875 12.125C0.291667 11.5417 0 10.8333 0 10C0 9.16667 0.291667 8.45833 0.875 7.875C1.45833 7.29167 2.16667 7 3 7C3.38333 7 3.75 7.071 4.1 7.213C4.45 7.355 4.76667 7.55067 5.05 7.8L12.1 3.7C12.0667 3.6 12.0417 3.48767 12.025 3.363C12.0083 3.23833 12 3.11733 12 3C12 2.16667 12.2917 1.45833 12.875 0.875C13.4583 0.291667 14.1667 0 15 0C15.8333 0 16.5417 0.291667 17.125 0.875C17.7083 1.45833 18 2.16667 18 3C18 3.83333 17.7083 4.54167 17.125 5.125C16.5417 5.70833 15.8333 6 15 6C14.6167 6 14.25 5.92933 13.9 5.788C13.55 5.64667 13.2333 5.45067 12.95 5.2L5.9 9.3C5.93333 9.4 5.95833 9.51267 5.975 9.638C5.99167 9.76333 6 9.884 6 10C6 10.116 5.99167 10.237 5.975 10.363C5.95833 10.489 5.93333 10.6013 5.9 10.7L12.95 14.8C13.2333 14.55 13.55 14.3543 13.9 14.213C14.25 14.0717 14.6167 14.0007 15 14C15.8333 14 16.5417 14.2917 17.125 14.875C17.7083 15.4583 18 16.1667 18 17C18 17.8333 17.7083 18.5417 17.125 19.125C16.5417 19.7083 15.8333 20 15 20Z"/>',
    },
    {
      boxY: 24,
      boxX: 24,
      name: "bold",
      svg: `<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "italic",
      svg: `<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "underline",
      svg: `<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "strikethrough",
      svg: `<path fill="currentColor" d="M28 15H17.956a40 40 0 0 0-1.338-.335c-2.808-.664-4.396-1.15-4.396-3.423a2.87 2.87 0 0 1 .787-2.145a4.8 4.8 0 0 1 3.013-1.09c2.83-.07 4.135.89 5.202 2.35l1.615-1.18a7.47 7.47 0 0 0-6.83-3.17a6.77 6.77 0 0 0-4.4 1.661a4.83 4.83 0 0 0-1.386 3.574A4.37 4.37 0 0 0 11.957 15H4v2h13.652c1.967.57 3.143 1.312 3.173 3.358a3.12 3.12 0 0 1-.862 2.393A5.82 5.82 0 0 1 16.243 24a6.63 6.63 0 0 1-5.145-2.691l-1.533 1.284A8.53 8.53 0 0 0 16.212 26h.1a7.67 7.67 0 0 0 5.048-1.819a5.08 5.08 0 0 0 1.465-3.853A4.95 4.95 0 0 0 21.675 17H28Z" />`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "undo",
      svg: `<path d="M3 7v6h6"></path><path d="M21 17a9 9 0 00-9-9 9 9 0 00-6 2.3L3 13"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "redo",
      svg: `<path d="M21 7v6h-6"></path><path d="M3 17a9 9 0 019-9 9 9 0 016 2.3l3 2.7"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "list-ul",
      svg: `<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><circle cx="3" cy="6" r="1"></circle><circle cx="3" cy="12" r="1"></circle><circle cx="3" cy="18" r="1"></circle>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "list-ol",
      svg: `<line x1="10" y1="6" x2="21" y2="6"></line><line x1="10" y1="12" x2="21" y2="12"></line><line x1="10" y1="18" x2="21" y2="18"></line><path d="M4 6h1v4H4zm0 6h1v4H4zm1 6H4c0-2 2-2 2-3 0-1.5-2-1.5-2-3h1"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "quote-right",
      svg: `<path d="M21 15a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM9 15a2 2 0 01-2 2H6a2 2 0 01-2-2v-3a2 2 0 012-2h3z"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "align-left",
      svg: `<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "align-center",
      svg: `<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "align-right",
      svg: `<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "link",
      svg: `<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "unlink",
      svg: `<path d="M18.84 12.25l1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71"></path><path d="M5.17 11.75l-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71"></path><line x1="8" y1="2" x2="8" y2="5"></line><line x1="2" y1="8" x2="5" y2="8"></line><line x1="16" y1="19" x2="16" y2="22"></line><line x1="19" y1="16" x2="22" y2="16"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "highlighter",
      svg: `<path d="M9 11l-6 6v3h9l3-3"></path><path d="M22 12l-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "image",
      svg: `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "youtube",
      svg: `<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "code",
      svg: `<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "table",
      svg: `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="3" y1="15" x2="21" y2="15"></line><line x1="9" y1="3" x2="9" y2="21"></line><line x1="15" y1="3" x2="15" y2="21"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "trash-alt",
      svg: `<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "columns",
      svg: `<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "grip-lines",
      svg: `<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "heading",
      svg: `<path d="M6 4v16M18 4v16M8 4h4M16 4h-4M8 20h4M16 20h-4M8 12h8"></path>`,
    },
    {
      boxY: 24,
      boxX: 24,
      name: "chevron-up",
      svg: `<polyline points="18 15 12 9 6 15"></polyline>`,
    },
  ];
  let displayIcon = icons.find((e) => e.name === name);
</script>

{#if displayIcon}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class={$$props.class}
    {focusable}
    {width}
    {height}
    {fill}
    stroke={color}
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 {displayIcon.boxY} {displayIcon.boxX}">
    {@html displayIcon.svg}
  </svg>
{:else}
  <span class="icon-not-found">ICONS error!</span>
{/if}

<style>
  .rotate-ninty {
    transform: rotate(90deg);
  }
</style>
